<template>
  <div>
    <div class="box box-default">
      <div class="box-header">
        <row style="text-align: center;">
          <h3 class="box-title dashboard-title">
            {{ $t("dashboard.for_rent") }}
          </h3>
        </row>
        <row style="text-align: center;">
          <div style="display: inline-block;">
            <div style="width:110px; margin-top:5px">
              <div class="input-group date">
                <date-picker
                  ref="periodPicker"
                  v-model="datePickerValue"
                  @dp-change="onHandleChangeMonth(datePickerValue)"
                  :config="optionsPicker"
                  :placeholder="$t('invoice.issuePeriod')"
                  readonly
                ></date-picker>
                <div class="input-group-addon" type="button" @click="$refs.periodPicker.dp.show()">
                  <i class="fa fa-caret-down"></i>
                </div>
              </div>
            </div>
          </div>
        </row>
      </div>
      <div class="box-body">
        <div class="chart"><LTEChart :chart-config="config"> </LTEChart></div>
      </div>
    </div>
  </div>
</template>

<script>
import LTEChart from "@/components/LTEChart";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'

export default {
  name: "RentalApartmentPerMonthPieChart",
  data() {
    return {
      datePickerValue: moment().format("YYYY/MM"),
      optionsPicker: {
        minDate: new Date(2019, 0),
        maxDate: moment(),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      config: {
        type: "pie",
        data: {
          labels: ["Căn Hộ Chưa Cho Thuê", "Căn Hộ Đang Cho Thuê"],
          datasets: []
        },
        options: {
          responsive: true,
          legend: {
            display: true,
            position: "top",
            labels: {
              usePointStyle: true
            }
          },
          tooltips: {
            mode: "index",
            intersect: false,
            callbacks: {
              label: function(tooltipItem, data) {
                let labels = data.labels;
                let currentLabel = labels[tooltipItem.index];
                let dataset = data.datasets[tooltipItem.datasetIndex];
                let currentValue = dataset.data[tooltipItem.index];
                let strLabel = `${currentLabel}: ${currentValue}%`;
                var sections = [];
                var words = strLabel.split(" ");
                var temp = "";
                words.forEach(function(item, index) {
                  if (temp.length > 0) {
                    var concat = temp + " " + item;
                    if (concat.length > 20) {
                      sections.push(temp);
                      temp = "";
                    } else {
                      if (index == words.length - 1) {
                        sections.push(concat);
                        return;
                      } else {
                        temp = concat;
                        return;
                      }
                    }
                  }
                  if (index == words.length - 1) {
                    sections.push(item);
                    return;
                  }
                  if (item.length < 20) {
                    temp = item;
                  } else {
                    sections.push(item);
                  }
                });
                return sections;
              }
            }
          },
          hover: {
            mode: "nearest",
            intersect: true
          }
        }
      }
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    }
  },
  computed: {
    ...mapGetters([
      "GET_LANG"
    ]),
    dateViewOptions: function() {
      return sessionStorage.getItem('projectDateViewOptions')
    }
  },
  methods: {
    ...mapActions([
      "GET_APARTMENT_RA_PER_REPORT"
    ]),
    onHandleChangeMonth: function(value) {
      this.renderChart();
    },
    renderChart: function(period) {
      const filter = {
        params: {
          ...utils.getAccountingPeriodFromDate(this.datePickerValue, "YYYY/MM")
        }
      };
      this.GET_APARTMENT_RA_PER_REPORT(filter).then(
        function(res) {
          let dataset = [];
          let datasets = [
            {
              backgroundColor: ["gray", "dodgerblue"],
              borderColor: ["gray", "dodgerblue"],
              data: []
            }
          ];
          let data = res;
          dataset[0] = data["not_rental_apartment_per"];
          dataset[1] = data["rental_apartment_per"];
          datasets[0].data = dataset;
          let clone_config = Object.assign({}, this.config);
          clone_config.data.datasets = datasets;
          this.config = clone_config;
        }.bind(this)
      );
    }
  },
  components: {
    LTEChart,
    "date-picker": datePicker
  },
  mounted() {
      this.renderChart();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-box-content {
  margin-left: 0px;
  line-height: 35px;
}

.info-box-number {
  display: inline;
  font-size: 14px;
  padding: 12px;
}

.info-box-title {
  font-size: 25px;
  color: black !important;
  background: linear-gradient(
    to top,
    #9c9e9f 0%,
    #9c9e9f 50%,
    #adada7 50%,
    #ccc1c1 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/RentalApartmentPerMonthPieChart.vue